

//import LinkIcon from '@material-ui/icons/Link';
//import LinkIcon from '@material-ui/icons/Launch';
//import LinkIcon from '@material-ui/icons/ChevronRight';
import LinkIcon from '@material-ui/icons/ArrowRight';


export  const routes_info = [
    { section: 'General',
        routes: [
            {
                title: 'home',
                link: '/',
                icon: LinkIcon,
                status: 'draft',
            },
            {
                title: 'about',
                link: '/about',
                icon: LinkIcon,
                status: 'draft',
            },
            {
                title: 'contact',
                link: '/contact',
                icon: LinkIcon,
                status: 'draft',
            },
        ],
    },


];

/*
const routes_menu = {
    'admin': {
        routes:[
            {
                path: '/admin/residents',
            }
        ]
    },
    'residents': {},
    'facilities': {},
    'home': {},
    'myaccount': {},
    'settings': {},
}
*/

/*
Make a list of the paths and titles in json object
iterate over the list and render all of the paths

make a component for list section 
- section parent
- pages
- sub pages

Routes:
--------------------------------

/admin/residents/
/admin/residents/create
/admin/residents/:id/view
/admin/residents/:id/edit

/admin/users/
/admin/clinicians/
/admin/pharmacies/
/admin/vital_types/
/admin/activity_types/
/admin/overview

--------------------------------
/residents/chart/medical/
/residents/chart/family/
/residents/chart/insurance/
/residents/chart/personal/

/residents/careplan/
/residents/careplan/list
/residents/careplan/:id/view
/residents/careplan/:id/edit

/residents/vitals/heartrate
/residents/vitals/bloodpressure
/residents/vitals/oxygensaturation
/residents/vitals/respiration
/residents/vitals/glucose

/residents/notes/
/residents/notes/create
/residents/notes/:id/view
/residents/notes/:id/edit

/residents/activity/bathroom/
/residents/activity/sleep/
/residents/activity/meals/
/residents/activity/physical/

/residents/diet/
/residents/diet/create
/residents/diet/:id/edit

/residents/meds/
/residents/meds/createprescription
/residents/meds/:id/refill
/residents/meds/:id/edit
/residents/meds/:id/view

/residents/labs/
/residents/labs/create
/residents/labs/:id/reorder
/residents/labs/:id/edit
/residents/labs/:id/view


--------------------------------
/facilties/overview/


--------------------------------
/myaccount/overview/
/myaccount/contactinfo
/myaccount/roles/
/myaccount/organization/
/myaccount/credentials/
/myaccount/plan/
/myaccount/history/
/myaccount/billing
--------------------------------


/sitemap/


*/